import { createApiMutationHook, IApiMutationFunction } from "@sol/sdk/utils/api";

import { IAIChatMessage } from "./aiMessageSendMutation";

export type IAIMessageRegenerateMutationParameters = {
    interactionUuid: string; // UUID of the exchange to regenerate
};

export type IAIMessageRegenerateMutationResult = IAIChatMessage;

export const aiMessageRegenerateMutation: IApiMutationFunction<IAIMessageRegenerateMutationParameters> = ({
    interactionUuid,
}) => {
    return {
        method: "POST",
        url: `/ai/regenerate/${interactionUuid}`,
    };
};

export const useAIMessageRegenerateMutation = createApiMutationHook<
    IAIMessageRegenerateMutationParameters,
    IAIMessageRegenerateMutationResult
>(aiMessageRegenerateMutation);
